import gql from 'graphql-tag';

export default gql`
    query GetPartials($boxDesc: Int, $stageSheetBoxId: Int) {
        getPartials(boxDesc: $boxDesc, stageSheetBoxId: $stageSheetBoxId) {
            stageSheetBoxId
            proppantId
            boxId
            boxDesc
            loadWeight
            splitWeight
            stageSheetId
            unAllocatedWeight
        }
    }
`;
